angular.module('picmonicng').directive('comments', [
  '$compile',
  function ($compile) {
    return {
      restrict: 'E',
      scope: {
        parent: '=',
        workflow: '<',
      },
      controller: [
        '$scope',
        'CommentsResource',
        'UserService',
        '$timeout',
        '$modal',
        '$rootScope',
        function ($scope, CommentsResource, UserService, $timeout, $modal, $rootScope) {
          $scope.UserService = UserService;
          $scope.upload_url = $rootScope.upload_url;
          $scope.comments = $scope.$parent.comments;
          $scope.slug = $scope.$parent.slug;
          var loading = false;
          if (!$scope.$parent.level) {
            $scope.level = 1;
          } else {
            $scope.level = $scope.$parent.level + 1;
          }

          $scope.moderate = function (comment, action) {
            if (!loading) {
              loading = true;
              CommentsResource.update({ comment_id: comment.comment_id, resource: action }, function (data) {
                loading = false;
                switch (action) {
                  case 'approve':
                  case 'remove':
                    comment.moderator_approved = data.moderator_approved;
                    comment.deleted_at = data.deleted_at;
                    break;
                  case 'endorse':
                    comment.endorsed = data.endorsed;
                    break;
                }
              });
            }
          };

          $scope.tag = function (comment, tag) {
            if (!loading) {
              loading = true;
              CommentsResource.update({ comment_id: comment.comment_id, resource: 'tag', tag: tag }, function (data) {
                loading = false;
                comment.tags = data.tags;
              });
            }
          };
          $scope.viewNotes = function (comment) {
            CommentsResource.get({ comment_id: comment.comment_id }, function (data) {
              var modalInstance = $modal.open({
                animation: true,
                templateUrl: '/templates/picmonic-admin/modals/adminv2/moderation/notes.html',
                controller: [
                  '$scope',
                  'category',
                  '$modalInstance',
                  function ($scope, category, $modalInstance) {
                    $scope.newNote = '';
                    $scope.category = category;
                    var loading = false;
                    $scope.close = function () {
                      $modalInstance.dismiss('cancel');
                    };
                    $scope.addNote = function () {
                      if (!loading) {
                        loading = true;
                        category.resource = 'note';
                        category.note = $scope.newNote;
                        category.$update(function () {
                          loading = false;
                          $scope.newNote = '';
                        });
                      }
                    };
                  },
                ],
                resolve: {
                  category: function () {
                    return data;
                  },
                },
              });
            });
          };

          $scope.softDelete = function (comment) {
            if (confirm('Are you sure you want to delete this comment?')) {
              comment.$delete();
            }
          };

          $scope.flag = function (comment) {
            var msg = comment.user_flag
              ? 'Are you sure you want to un-flag this comment as inappropriate?'
              : 'Are you sure you want to flag this comment as inappropriate?';
            if (UserService.user.user_id) {
              if (confirm(msg)) {
                if (comment.user_flag) {
                  CommentsResource.delete(
                    {
                      resource: 'flags',
                      resource_id: comment.user_flag.comment_flag_id,
                    },
                    comment.user_flag
                  );
                  comment.user_flag = null;
                } else {
                  comment.user_flag = CommentsResource.save({
                    resource: 'flags',
                    comment_id: comment.comment_id,
                  });
                }
              }
            }
          };

          $scope.toggleReply = function (comment, $event) {
            comment.showReply = !comment.showReply;
            $timeout(function () {
              $($event.target).parent().parent().parent().find('textarea').focus();
            }, 0);
          };
        },
      ],
      templateUrl: '/templates/directives/comments.html',
      compile: function (tElement, tAttr, transclude) {
        var contents = tElement.contents().remove();
        var compiledContents;
        return function (scope, iElement, iAttr) {
          if (!compiledContents) {
            compiledContents = $compile(contents, transclude);
          }
          compiledContents(scope, function (clone, scope) {
            iElement.append(clone);
          });
        };
      },
    };
  },
]);
